import { useContext } from "react";
import Axios from "axios";
import { SavingsCalculatorContext } from "../context";

const parseEfficiency = (value) => {
    const n = parseFloat(String(value).replace(",", "."));
    return Number.isFinite(n) ? n : NaN;
};

const useSavingsData = () => {
    const [state, setState, config] = useContext(SavingsCalculatorContext);

    const getResults = () => state.results || {};

    const getResultFor = (id) => (state.results || {})[parseInt(id, 10)] || null;

    const isCalculating = () =>
        Object.values(state.results || {}).some((r) => r && r.loading);

    // Lista para el panel comparativo: [{ version, result }] en orden de selección.
    const getComparison = () =>
        (state.selectedVersionIds || []).map((id) => ({
            id,
            version: (state.versions || []).find((v) => v.id === id) || null,
            entry: (state.results || {})[id] || null,
        }));

    const inputsAreValid = () => {
        const { efficiency, annualKm } = state.currentVehicle;
        const eff = parseEfficiency(efficiency);
        const km = parseInt(annualKm, 10);
        return eff > 0 && km > 0 && (state.selectedVersionIds || []).length > 0;
    };

    // Dispara un POST /calculate/ por cada versión seleccionada (máx 4) y guarda
    // los resultados. Toda la aritmética de dinero vive en el backend.
    const runCalculation = () => {
        if (!inputsAreValid()) {
            setState((prev) => ({ ...prev, results: {} }));
            return;
        }

        const { fuelType, efficiency, annualKm } = state.currentVehicle;
        const ids = state.selectedVersionIds;

        // Marcar todas las versiones seleccionadas como "calculando".
        setState((prev) => {
            const results = {};
            ids.forEach((id) => {
                results[id] = { result: prev.results[id]?.result || null, loading: true, error: null };
            });
            return { ...prev, results };
        });

        ids.forEach((id) => {
            const payload = {
                version_id: id,
                user_efficiency: parseEfficiency(efficiency),
                user_fuel_type: fuelType,
                annual_km: parseInt(annualKm, 10),
            };
            Axios.post(config.calculateUrl, payload)
                .then((response) => {
                    setState((prev) => ({
                        ...prev,
                        results: {
                            ...prev.results,
                            [id]: { result: response.data, loading: false, error: null },
                        },
                    }));
                })
                .catch((error) => {
                    console.error("[savings-calculator] calculate failed", id, error);
                    setState((prev) => ({
                        ...prev,
                        results: {
                            ...prev.results,
                            [id]: { result: null, loading: false, error: true },
                        },
                    }));
                });
        });
    };

    return {
        getResults,
        getResultFor,
        getComparison,
        isCalculating,
        inputsAreValid,
        runCalculation,
    };
};

export default useSavingsData;
